const SetLSSearchCondition = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const formIds = [
      'search__condition-form',
      'search__condition-keyword-form'
    ];

    formIds.forEach((id) => {
      const form = document.getElementById(id) as HTMLFormElement | null;
      if (!form) return;

      form.addEventListener('submit', (e: SubmitEvent) => {
        const formData = new FormData(form);
        const query = new URLSearchParams(formData as any).toString();

        // ローカルストレージに上書き保存
        localStorage.setItem('searchQuery', query);

        // console.log(`保存されたクエリ: ${query}`);
        // e.preventDefault();
      });
    });
  });
};

export default SetLSSearchCondition;
